module.exports = __webpack_public_path__ + "components/flag/static/square/as-51c4295aec0a2b2530b860dcc693d09d.svg";